import React from "react";

import { TextPage } from "../components/TextPage";

const mdString = `✅ Непрестанно Молитись
✅ Сон, спорт, здорове харчування
✅ Берегти якийсь один контекст у дні, бо інакше важко навіть аналізувати
✅ По вечорах вирубати все к єбєням як тимчасову і низькопріоритетну дічь
✅ Постійно робити фото свого життя
✅ Постійно робити скріни відосів, статтей, програмок, книжок, особливо всяких цитат
✅ Допомагати людям і майже не паритись як це вплине на personal brand
✅ Робити зауваження лише коли затрачений час вартий того
✅ Їсти до 6. Пізніше взагалі нічого не їсти
✅ Записування майлстоунів
✅ Якщо дізнаюсь якусь інфу яка відчуваю, що може бути корисна знову - зберегти в закладки. А в ідеалі навіть додати в obsidian`;

export const PageHabits = () => {
    return <TextPage heading="Habits" mdString={mdString} />;
};
